var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tech-comment-collapse" },
    [
      _vm.canEdit && _vm.parsedComments.length < 1
        ? _c("div", { staticClass: "section-desc margin-bottom" }, [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.$t("tenantProjects.submission.comment.addTechCommentHint")
                ) +
                "\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.parsedComments, function (section, index) {
        return _c(
          "Collapse",
          {
            key: section.id,
            attrs: {
              id: "tech-comment-collapse-" + index,
              enableExpandByClickingTitle: !_vm.isEdit[section.itemId],
              titleContainerClass: { "is-editing": _vm.isEdit[section.itemId] },
            },
          },
          [
            _c("template", { slot: "title" }, [
              _c(
                "div",
                { staticClass: "section-title-box" },
                [
                  _vm.isEdit[section.itemId]
                    ? _c("div", { staticClass: "section-title-editing" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: section.displayOrder,
                              expression: "section.displayOrder",
                            },
                          ],
                          staticClass: "section-title-order",
                          attrs: {
                            placeholder: _vm.$t(
                              "tenantProjects.submission.comment.section.number"
                            ),
                            type: "text",
                          },
                          domProps: { value: section.displayOrder },
                          on: {
                            change: function (event) {
                              return _vm.changeSection(
                                section,
                                "displayOrder",
                                event.target.value
                              )
                            },
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                section,
                                "displayOrder",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: section.value,
                              expression: "section.value",
                            },
                          ],
                          staticClass: "section-title-text",
                          attrs: {
                            placeholder: _vm.$t(
                              "tenantProjects.submission.comment.section.title"
                            ),
                            type: "text",
                          },
                          domProps: { value: section.value },
                          on: {
                            change: function (event) {
                              return _vm.changeSection(
                                section,
                                "value",
                                event.target.value
                              )
                            },
                            blur: function ($event) {
                              return _vm.onBlurSave(section)
                            },
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(section, "value", $event.target.value)
                            },
                          },
                        }),
                      ])
                    : [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: section.displayOrder,
                                expression: "section.displayOrder",
                              },
                            ],
                          },
                          [_vm._v(_vm._s(section.displayOrder + "."))]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "section-title" }, [
                          _vm._v(_vm._s(section.value)),
                        ]),
                      ],
                  _vm._v(" "),
                  section.lastActionText
                    ? _c("div", { staticClass: "update-history__text" }, [
                        _c("span", [_vm._v(_vm._s(section.lastActionText))]),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _vm.canEdit && !_vm.isEdit[section.itemId]
              ? _c(
                  "div",
                  {
                    staticClass: "additional-container",
                    class: { hidden: !_vm.canEdit },
                    attrs: { slot: "additional" },
                    slot: "additional",
                  },
                  [
                    _c("DottedMenu", [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.editSection(section, index)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("action.edit")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.addSection(section, index)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("action.add")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.openDelModalForSection(section, index)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("action.delete")))]
                      ),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "template",
              { slot: "content" },
              _vm._l(section.sectionContent, function (line, i) {
                return _c("div", { key: i, staticClass: "content-box" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isEdit[line.itemId],
                          expression: "!isEdit[line.itemId]",
                        },
                      ],
                      staticClass: "section-list-item",
                      class: { "with-options": _vm.canEdit },
                    },
                    [
                      _c("div", [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showSeq(line),
                                expression: "showSeq(line)",
                              },
                            ],
                            staticClass: "section-list-item__number",
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.showSeq(line) + ".") +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("pre", { staticClass: "section-list-item__value" }, [
                          _vm._v(_vm._s(line.value)),
                        ]),
                      ]),
                      _vm._v(" "),
                      line.lastActionText
                        ? _c("div", { staticClass: "update-history__text" }, [
                            _c("span", [_vm._v(_vm._s(line.lastActionText))]),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit[line.itemId],
                          expression: "isEdit[line.itemId]",
                        },
                      ],
                      staticClass: "tech-comment-text",
                    },
                    [
                      _c("textarea", {
                        directives: [
                          { name: "autosize", rawName: "v-autosize" },
                          { name: "hkldinput", rawName: "v-hkldinput" },
                        ],
                        ref: _vm.getLineRefName(index, i),
                        refInFor: true,
                        attrs: {
                          placeholder: _vm.$t(
                            "tenantProjects.submission.comment.section.content"
                          ),
                          type: "text",
                        },
                        domProps: { value: line.value || "" },
                        on: {
                          change: function (event) {
                            return _vm.changeLine(
                              section,
                              line,
                              event.target.value
                            )
                          },
                          focusout: function ($event) {
                            return _vm.onBlurSave(line)
                          },
                        },
                      }),
                      _vm._v(" "),
                      line.lastActionText
                        ? _c("div", { staticClass: "update-history__text" }, [
                            _c("span", [_vm._v(_vm._s(line.lastActionText))]),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.canEdit && !_vm.isEdit[line.itemId]
                    ? _c(
                        "div",
                        { staticClass: "tech-comment-accordion-menu" },
                        [
                          _c("DottedMenu", [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.editLine(line, index, i)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("action.edit")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.addLine(section, i)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("action.add")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openDelModalForLine(
                                      section,
                                      line
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("action.delete")))]
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ])
              }),
              0
            ),
          ],
          2
        )
      }),
      _vm._v(" "),
      _c("ActionConfirmModel", {
        ref: "deleteCommentModal",
        attrs: {
          confirmTitle: "deleteConfirmMsg",
          confirmBtnName: "action.delete",
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }